import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n, { getLanguageFromLocale, languageOptions } from 'locale';
import { Dropdown } from 'components/_new/Dropdown';
import type { DropdownItem } from 'components/_new/Dropdown';

const LanguageSwitcher = () => {
	const { t } = useTranslation();

	const valueTemplate = (option: DropdownItem | null) => {
		if (!option) return null;
		const Flag = languageOptions.find(({ value }) => value === option.value)?.Flag || null;
		return (
			<div className="flex items-center gap-2">
				{Flag && <Flag style={{ width: '1.125rem' }} />}
				<span>{option.label}</span>
			</div>
		);
	};

	const currentLanguage = useMemo(() => {
		const baseLanguage = getLanguageFromLocale(i18n.language);
		const matchingOption = languageOptions.find((option) => option.value === baseLanguage);
		return matchingOption || languageOptions[0];
	}, [i18n.language]);

	const languageLabel = t('programPanel.usersLanguage');

	return (
		<div className="flex align-items-center gap-2">
			<label htmlFor="language-dropdown" className="text-gray-700">
				{languageLabel}:
			</label>
			<Dropdown
				inputId="language-dropdown"
				value={currentLanguage.value}
				options={languageOptions}
				onChange={({ value }) => {
					i18n.changeLanguage(value);
				}}
				valueTemplate={valueTemplate}
				itemTemplate={valueTemplate}
				aria-label={languageLabel}
			/>
		</div>
	);
};

export default LanguageSwitcher;
